export default "__VITE_PUBLIC_ASSET__01f9342c__"